import React from 'react';
import { motion } from 'framer-motion';
import { Facebook, Instagram } from 'lucide-react';

const SocialMediaSection = () => {
  const socialLinks = [
  {
    id: 1,
    name: 'Facebook',
    icon: Facebook,
    url: 'https://www.facebook.com/profile.php?id=61550308602004',
    color: 'hover:text-[#1877F2]'
  },
  {
    id: 2,
    name: 'Instagram',
    icon: Instagram,
    url: 'https://www.instagram.com/kahloveramx/',
    color: 'hover:text-[#E4405F]'
  }];


  return (
    <section className="py-16 bg-background pt-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center">

          {/* Heading */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-6">
            Follow Us on <span className="text-primary">Social Media</span>
          </h2>

          <p className="text-lg text-muted-foreground font-body max-w-2xl mx-auto mb-10">
            Stay connected with us for the latest updates, special offers, and behind-the-scenes moments
          </p>

          {/* Social Icons */}
          <div className="flex justify-center items-center gap-6 sm:gap-8">
            {socialLinks?.map((social) => {
              const IconComponent = social?.icon;
              return (
                <motion.a
                  key={social?.id}
                  href={social?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  whileHover={{ scale: 1.2, rotate: 5 }}
                  whileTap={{ scale: 0.9 }}
                  transition={{ duration: 0.3 }}
                  viewport={{ once: true }}
                  className={`w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-primary/10 border-2 border-primary flex items-center justify-center text-primary transition-all duration-300 ${social?.color} hover:bg-primary/20 hover:border-primary/80 shadow-warm hover:shadow-warm-lg`}
                  aria-label={`Follow us on ${social?.name}`}>
                  <IconComponent size={28} strokeWidth={2} />
                </motion.a>
              );

            })}
          </div>
        </motion.div>
      </div>
    </section>
  );

};

export default SocialMediaSection;